import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import { doGTranslate } from '../../../scripts/initTranslate.js';
import { speechUtteranceChunker } from '../../../scripts/textToSpeech.min.js';
import { GrResume, GrPlay, GrPause, GrRefresh } from 'react-icons/gr';
import './style.scoped.scss';

//#region Flags
import en from '../../../assets/images/translate/en.png';
import fr from '../../../assets/images/translate/fr.png';
import china from '../../../assets/images/translate/zh-CN.png';
import it from '../../../assets/images/translate/it.png';
import es from '../../../assets/images/translate/es.png';
import de from '../../../assets/images/translate/de.png';
import pt from '../../../assets/images/translate/pt.png';
import ru from '../../../assets/images/translate/ru.png';
import vi from '../../../assets/images/translate/vi.png';
import el from '../../../assets/images/translate/el.png';
import tl from '../../../assets/images/translate/tl.png';
import hi from '../../../assets/images/translate/hi.png';
import nl from '../../../assets/images/translate/nl.png';
import km from '../../../assets/images/translate/km.png';
import id from '../../../assets/images/translate/id.png';
import ja from '../../../assets/images/translate/ja.png';
import ko from '../../../assets/images/translate/ko.png';
import lo from '../../../assets/images/translate/lo.png';
import my from '../../../assets/images/translate/my.png';
import th from '../../../assets/images/translate/th.png';
import ar from '../../../assets/images/translate/ar.png';
import pl from '../../../assets/images/translate/pl.png';
import us from '../../../assets/images/translate/en-us.png';
import mx from '../../../assets/images/translate/es-mx.png';
import aus from '../../../assets/images/translate/aus.svg';
import br from '../../../assets/images/translate/pt-br.png';
import mi from '../../../assets/images/translate/mi.png';
import ms from '../../../assets/images/translate/ms.png';
import si from '../../../assets/images/translate/si.svg';
import eg from '../../../assets/images/translate/eg.png';
//#endregion

const Translate = ({ flagsList }) => {
  const [text, setText] = useState('');
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [language, setLanguage] = useState('');

  useEffect(() => {
    setText(getText());

    // const wfTranslator = document.getElementById('wfTranslator');
    // const placeholder = document.getElementById(
    //   'translate-component-placeholder'
    // );
    // const hidden = document.getElementById('translate-component-hidden');

    // // placed translate in hidden placeholder to ensure it is only initialized once
    // if (placeholder.childElementCount < 1) {
    //   placeholder.insertAdjacentElement('beforeend', wfTranslator);
    // }

    // return the translate element to the hidden element once this component unmounts
    return () => {
      // hidden.insertAdjacentElement('beforeend', wfTranslator);
      setText('');
    };
  }, []);

  useEffect(() => {
    $('.main-content-wrapper').on('DOMSubtreeModified', () => {
      const text = getText();
      setText(text);
    });
  });

  // useEffect(() => {
  //   const translate = document.querySelector('select.goog-te-combo');
  //   console.log('Translate DOM', translate);
  //   translate.addEventListener('change', () => {
  //     setTimeout(() => {
  //       setText(getText());
  //     }, 2000);
  //   });
  // }, []);

  const loadSpeech = (text) => {
    window.speechSynthesis.cancel();
    const speech = new SpeechSynthesisUtterance();
    speech.text = text;
    speech.rate = 1.2;
    speechUtteranceChunker(
      speech,
      {
        chunkLength: 120,
      },
      () => {
        console.info('text to speech done');
      }
    );
  };

  const getText = () => {
    const documentName = document.getElementById('docTitle')
      ? document.getElementById('docTitle').textContent
      : '';
    const title = document.getElementById('pageTitle')
      ? document.getElementById('pageTitle').textContent
      : '';
    const content = document.getElementById('content')
      ? document.getElementById('content').textContent
      : '';
    const text = `${documentName}. ${title}. ${content}`;
    return text;
  };

  const translate = (language) => {
    // const placeholder = document.getElementById(
    //   'translate-component-placeholder'
    // );
    // const wfTranslator = document.getElementById('wfTranslator');

    // if (placeholder.childElementCount < 1) {
    //   placeholder.insertAdjacentElement('beforeend', wfTranslator);
    // }

    doGTranslate(language);
    setLanguage(language);
  };

  useEffect(() => {
    const userLanguage = document.documentElement.lang;
    if (userLanguage) setSelectedLanguage(userLanguage);
  }, [language]);

  // to remove dropdown duplicate
  // if (document.getElementsByClassName('goog-te-combo').length > 1) {
  //   document
  //     .getElementsByClassName('goog-te-combo')
  //     [document.getElementsByClassName('goog-te-combo').length - 1].remove();
  // }

  return (
    <React.Fragment>
      {flagsList && flagsList.length > 0 ? (
        <div className='wf-translate-flags pt-2'>
          <div
            className={`wf-translate-flags__group${
              flagsList.length > 10 ? ' lg-list' : ''
            }`}
          >
            {flagsList.map((flag, i) => {
              switch (flag) {
                case 'en': {
                  return (
                    <img
                      key={i}
                      src={en}
                      onClick={() => translate('en|en')}
                      alt='Translate to English'
                    />
                  );
                }
                case 'fr': {
                  return (
                    <img
                      src={fr}
                      key={i}
                      onClick={() => translate('en|fr')}
                      alt='Translate to French'
                    />
                  );
                }
                case 'zh-CN': {
                  return (
                    <img
                      src={china}
                      key={i}
                      onClick={() => translate('en|zh-CN')}
                      alt='Translate to Chinese'
                    />
                  );
                }
                case 'it': {
                  return (
                    <img
                      src={it}
                      key={i}
                      onClick={() => translate('en|it')}
                      alt='Translate to Italian'
                    />
                  );
                }
                case 'es': {
                  return (
                    <img
                      src={es}
                      key={i}
                      onClick={() => translate('en|es')}
                      alt='Translate to Spanish'
                    />
                  );
                }
                case 'de': {
                  return (
                    <img
                      src={de}
                      key={i}
                      onClick={() => translate('en|de')}
                      alt='Translate to Deutsch'
                    />
                  );
                }
                case 'pt': {
                  return (
                    <img
                      src={pt}
                      key={i}
                      onClick={() => translate('en|pt')}
                      alt='Translate to Portuguese'
                    />
                  );
                }
                case 'ru': {
                  return (
                    <img
                      src={ru}
                      key={i}
                      onClick={() => translate('en|ru')}
                      alt='Translate to Russian'
                    />
                  );
                }
                case 'vi': {
                  return (
                    <img
                      src={vi}
                      key={i}
                      onClick={() => translate('en|vi')}
                      alt='Translate to Vietnamese'
                    />
                  );
                }
                case 'el': {
                  return (
                    <img
                      src={el}
                      key={i}
                      onClick={() => translate('en|el')}
                      alt='Translate to Greek'
                    />
                  );
                }
                case 'tl': {
                  return (
                    <img
                      src={tl}
                      key={i}
                      onClick={() => translate('en|tl')}
                      alt='Translate to Filipino'
                    />
                  );
                }
                case 'hi': {
                  return (
                    <img
                      src={hi}
                      key={i}
                      onClick={() => translate('en|hi')}
                      alt='Translate to Hindi'
                    />
                  );
                }
                case 'nl': {
                  return (
                    <img
                      src={nl}
                      key={i}
                      onClick={() => translate('en|nl')}
                      alt='Translate to Dutch'
                    />
                  );
                }
                case 'km': {
                  return (
                    <img
                      src={km}
                      key={i}
                      onClick={() => translate('en|km')}
                      alt='Translate to Khmer'
                    />
                  );
                }
                case 'id': {
                  return (
                    <img
                      src={id}
                      key={i}
                      onClick={() => translate('en|id')}
                      alt='Translate to Indonesian'
                    />
                  );
                }
                case 'ja': {
                  return (
                    <img
                      src={ja}
                      key={i}
                      onClick={() => translate('en|ja')}
                      alt='Translate to Japanese'
                    />
                  );
                }
                case 'ko': {
                  return (
                    <img
                      src={ko}
                      key={i}
                      onClick={() => translate('en|ko')}
                      alt='Translate to Korean'
                    />
                  );
                }
                case 'lo': {
                  return (
                    <img
                      src={lo}
                      key={i}
                      onClick={() => translate('en|lo')}
                      alt='Translate to Lao'
                    />
                  );
                }
                case 'my': {
                  return (
                    <img
                      src={my}
                      key={i}
                      onClick={() => translate('en|my')}
                      alt='Translate to Burmese'
                    />
                  );
                }
                case 'th': {
                  return (
                    <img
                      src={th}
                      key={i}
                      onClick={() => translate('en|th')}
                      alt='Translate to Thai'
                    />
                  );
                }
                case 'ar': {
                  return (
                    <img
                      src={ar}
                      key={i}
                      onClick={() => translate('en|ar')}
                      alt='Translate to Arabic'
                    />
                  );
                }
                case 'pl': {
                  return (
                    <img
                      src={pl}
                      key={i}
                      onClick={() => translate('en|pl')}
                      alt='Translate to Polish'
                    />
                  );
                }
                case 'en-us': {
                  return (
                    <img
                      src={us}
                      key={i}
                      onClick={() => translate('en|en')}
                      alt='Translate to English'
                    />
                  );
                }
                case 'es-mx': {
                  return (
                    <img
                      src={mx}
                      key={i}
                      onClick={() => translate('en|es')}
                      alt='Translate to Spanish'
                    />
                  );
                }
                case 'aus': {
                  return (
                    <img
                      src={aus}
                      key={i}
                      style={{ borderRadius: '15%' }}
                      onClick={() => translate('en|en')}
                      alt='Translate to English'
                    />
                  );
                }
                case 'pt-br': {
                  return (
                    <img
                      src={br}
                      key={i}
                      onClick={() => translate('en|pt')}
                      alt='Translate to Portuguese'
                    />
                  );
                }
                case 'mi': {
                  return (
                    <img
                      src={mi}
                      key={i}
                      onClick={() => translate('en|mi')}
                      alt='Translate to Maori'
                    />
                  );
                }
                case 'ms': {
                  return (
                    <img
                      src={ms}
                      key={i}
                      onClick={() => translate('en|ms')}
                      alt='Translate to Malay'
                    />
                  );
                }
                case 'si': {
                  return (
                    <img
                      src={si}
                      style={{
                        boxShadow: '0 0 3px 0px #888',
                        height: '100%',
                        maxHeight: '21px',
                        margin: 'auto 0',
                      }}
                      key={i}
                      onClick={() => translate('en|ms')}
                      alt='Translate to Malay'
                    />
                  );
                }
                case 'eg': {
                  return (
                    <img
                      src={eg}
                      style={{
                        boxShadow: '0 0 3px 0px #888',
                        height: '100%',
                        maxHeight: '21px',
                        margin: 'auto 0',
                      }}
                      key={i}
                      onClick={() => translate('en|ar')}
                      alt='Translate to Arabic'
                    />
                  );
                }
                default:
                  return <React.Fragment></React.Fragment>;
              }
            })}
          </div>
        </div>
      ) : null}

      <div id='translate-component-placeholder'></div>
      <div id='wfTranslator'>
        <div className=' goog-te-gadget' dir='ltr'>
          <div id='targetLanguage'>
            <select
              className='goog-te-combo'
              aria-label='Language Translate Widget'
              onChange={(e) => translate(`en|${e.target.value}`)}
              value={selectedLanguage}
            >
              <option value=''>Select Language</option>
              <option value='af'>Afrikaans</option>
              <option value='sq'>Albanian</option>
              <option value='am'>Amharic</option>
              <option value='ar'>Arabic</option>
              <option value='hy'>Armenian</option>
              <option value='as'>Assamese</option>
              <option value='ay'>Aymara</option>
              <option value='az'>Azerbaijani</option>
              <option value='bm'>Bambara</option>
              <option value='eu'>Basque</option>
              <option value='be'>Belarusian</option>
              <option value='bn'>Bengali</option>
              <option value='bho'>Bhojpuri</option>
              <option value='bs'>Bosnian</option>
              <option value='bg'>Bulgarian</option>
              <option value='ca'>Catalan</option>
              <option value='ceb'>Cebuano</option>
              <option value='ny'>Chichewa</option>
              <option value='zh-CN'>Chinese (Simplified)</option>
              <option value='zh-TW'>Chinese (Traditional)</option>
              <option value='co'>Corsican</option>
              <option value='hr'>Croatian</option>
              <option value='cs'>Czech</option>
              <option value='da'>Danish</option>
              <option value='dv'>Dhivehi</option>
              <option value='doi'>Dogri</option>
              <option value='nl'>Dutch</option>
              <option value='en'>English</option>
              <option value='eo'>Esperanto</option>
              <option value='et'>Estonian</option>
              <option value='ee'>Ewe</option>
              <option value='tl'>Filipino</option>
              <option value='fi'>Finnish</option>
              <option value='fr'>French</option>
              <option value='fy'>Frisian</option>
              <option value='gl'>Galician</option>
              <option value='ka'>Georgian</option>
              <option value='de'>German</option>
              <option value='el'>Greek</option>
              <option value='gn'>Guarani</option>
              <option value='gu'>Gujarati</option>
              <option value='ht'>Haitian Creole</option>
              <option value='ha'>Hausa</option>
              <option value='haw'>Hawaiian</option>
              <option value='iw'>Hebrew</option>
              <option value='hi'>Hindi</option>
              <option value='hmn'>Hmong</option>
              <option value='hu'>Hungarian</option>
              <option value='is'>Icelandic</option>
              <option value='ig'>Igbo</option>
              <option value='ilo'>Ilocano</option>
              <option value='id'>Indonesian</option>
              <option value='ga'>Irish Gaelic</option>
              <option value='it'>Italian</option>
              <option value='ja'>Japanese</option>
              <option value='jw'>Javanese</option>
              <option value='kn'>Kannada</option>
              <option value='kk'>Kazakh</option>
              <option value='km'>Khmer</option>
              <option value='rw'>Kinyarwanda</option>
              <option value='gom'>Konkani</option>
              <option value='ko'>Korean</option>
              <option value='kri'>Krio</option>
              <option value='ku'>Kurdish (Kurmanji)</option>
              <option value='ckb'>Kurdish (Sorani)</option>
              <option value='ky'>Kyrgyz</option>
              <option value='lo'>Lao</option>
              <option value='la'>Latin</option>
              <option value='lv'>Latvian</option>
              <option value='ln'>Lingala</option>
              <option value='lt'>Lithuanian</option>
              <option value='lg'>Luganda</option>
              <option value='lb'>Luxembourgish</option>
              <option value='mk'>Macedonian</option>
              <option value='mai'>Maithili</option>
              <option value='mg'>Malagasy</option>
              <option value='ms'>Malay</option>
              <option value='ml'>Malayalam</option>
              <option value='mt'>Maltese</option>
              <option value='mi'>Maori</option>
              <option value='mr'>Marathi</option>
              <option value='mni-Mtei'>Meiteilon (Manipuri)</option>
              <option value='lus'>Mizo</option>
              <option value='mn'>Mongolian</option>
              <option value='my'>Myanmar (Burmese)</option>
              <option value='ne'>Nepali</option>
              <option value='no'>Norwegian</option>
              <option value='or'>Odia (Oriya)</option>
              <option value='om'>Oromo</option>
              <option value='ps'>Pashto</option>
              <option value='fa'>Persian</option>
              <option value='pl'>Polish</option>
              <option value='pt'>Portuguese</option>
              <option value='pa'>Punjabi</option>
              <option value='qu'>Quechua</option>
              <option value='ro'>Romanian</option>
              <option value='ru'>Russian</option>
              <option value='sm'>Samoan</option>
              <option value='sa'>Sanskrit</option>
              <option value='gd'>Scots Gaelic</option>
              <option value='nso'>Sepedi</option>
              <option value='sr'>Serbian</option>
              <option value='st'>Sesotho</option>
              <option value='sn'>Shona</option>
              <option value='sd'>Sindhi</option>
              <option value='si'>Sinhala</option>
              <option value='sk'>Slovak</option>
              <option value='sl'>Slovenian</option>
              <option value='so'>Somali</option>
              <option value='es'>Spanish</option>
              <option value='su'>Sundanese</option>
              <option value='sw'>Swahili</option>
              <option value='sv'>Swedish</option>
              <option value='tg'>Tajik</option>
              <option value='ta'>Tamil</option>
              <option value='tt'>Tatar</option>
              <option value='te'>Telugu</option>
              <option value='th'>Thai</option>
              <option value='ti'>Tigrinya</option>
              <option value='ts'>Tsonga</option>
              <option value='tr'>Turkish</option>
              <option value='tk'>Turkmen</option>
              <option value='ak'>Twi</option>
              <option value='uk'>Ukrainian</option>
              <option value='ur'>Urdu</option>
              <option value='ug'>Uyghur</option>
              <option value='uz'>Uzbek</option>
              <option value='vi'>Vietnamese</option>
              <option value='cy'>Welsh</option>
              <option value='xh'>Xhosa</option>
              <option value='yi'>Yiddish</option>
              <option value='yo'>Yoruba</option>
              <option value='zu'>Zulu</option>
            </select>
          </div>
        </div>
      </div>
      <div className='org-textToSpeech'>
        <button
          type='button'
          className='speech-button'
          aria-label='Text to speech Play'
          onClick={() => {
            if (!window.speechSynthesis.speaking) {
              loadSpeech(text);
            }
          }}
          title='Play'
        >
          <GrPlay />
        </button>
        <button
          type='button'
          className='speech-button'
          aria-label='Text to speech Pause'
          onClick={() => {
            if (window.speechSynthesis.speaking) {
              window.speechSynthesis.pause();
            }
          }}
          title='Pause'
        >
          <GrPause />
        </button>
        <button
          type='button'
          className='speech-button'
          aria-label='Text to speech Pause'
          onClick={() => {
            window.speechSynthesis.resume();
          }}
          title='Resume'
        >
          <GrResume />
        </button>
        <button
          type='button'
          className='speech-button'
          aria-label='Refresh Content'
          onClick={() => window.location.reload()}
          title='Refresh Content'
        >
          <GrRefresh />
        </button>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  page: state.document.currentPage,
  flagsList: state.client.flagsList,
});

const connector = connect(mapStateToProps, null);

export default connector(Translate);
